import { Dialog } from "radix-ui";
import DialogContent from "../../molecules/dialog/DialogContent";
import { useDialog } from "../../../hooks/useDialog";

export default function DialogMessage() {
  const { dialog, hideDialog } = useDialog();

  return (
    <Dialog.Root
      open={dialog.open}
      onOpenChange={(open) => !open && hideDialog()}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 z-40" />
        <Dialog.Content
          className={`
              fixed left-1/2 top-1/2 w-[90vw] max-w-md
              -translate-x-1/2 -translate-y-1/2
              rounded-lg bg-white p-6 shadow-lg focus:outline-none
              ${
                dialog.centered
                  ? ""
                  : "lg:left-[75%] lg:top-1/2 lg:-translate-x-1/2 lg:-translate-y-1/2"
              }
              transition-transform duration-200 ease-out
              z-50
            `}
        >
          <DialogContent
            title={dialog.title}
            message={dialog.message}
            buttonLabel={dialog.buttonLabel}
            secondaryButtonLabel={dialog.secondaryButtonLabel}
            showIcon={dialog.showIcon}
            iconType={dialog.iconType}
            onModalSubmit={dialog.onModalSubmit}
          />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
